import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BlogCard from './BlogCard';
import BlogModal from './BlogModal';
import { useDoctorQuery } from '../../hooks/useDoctorQuery';
import drEasyApi from '../../Api/Customapi';
import { useDoctorContext } from '../../context/DoctorContext';
import { useLanguage } from '../../context/LanguageContext';

export default function BlogsSection() {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedBlog, setSelectedBlog] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { data: doctor } = useDoctorQuery();
    const { setHasBlogs } = useDoctorContext();
    const { t ,currentLanguage} = useLanguage();
    const navigate = useNavigate();
    const { slug } = useParams();
    const url = window.location.href;
    const currentPath = url.substring(url.lastIndexOf('/') + 1);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const res = await drEasyApi.get('/api/Blogs/GetDoctorBlogs', {
                    params: { DoctorId: doctor?.id },
                });
                setBlogs(res.data || []);
                if(res?.data?.length > 0){
                    setHasBlogs(true);
                }
            } catch (err) {
                console.error('Failed to load blogs', err);
            } finally {
                setLoading(false);
            }
        };
        if (doctor?.id) {
            fetchBlogs();
        }
    }, [doctor?.id,currentLanguage]);

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                handleCloseModal();
            }
        };

        if (isModalOpen) {
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [isModalOpen]);

    if (!loading && blogs.length === 0) {
        setHasBlogs(false);
        return null;
    }

    const handleSeeMore = () => {
        navigate(`/${slug}/blogs`);
    };

    const handleOpenModal = (blog) => {
        setSelectedBlog(blog);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedBlog(null);
    };

    // Show all blogs if current path is "blogs", otherwise show only first 3
    const displayedBlogs = currentPath === "blogs" ? blogs : blogs.slice(0, 3);
    const hasMoreBlogs = currentPath !== "blogs" && blogs.length > 3;
    console.log('====================================');
    console.log(blogs);
    console.log('====================================');
    return (
        <>
            <section className="bg-gradient-to-br py-16 px-4 sm:px-10 lg:px-20">
                <div className="text-center mb-14">
                    <h2 className="text-4xl font-bold text-textPrimary tracking-tight">
                        {t('blogs.title')}
                    </h2>
                    <p className="mt-3 text-textPrimary/70 max-w-2xl mx-auto">
                        {t('blogs.description')}
                    </p>
                </div>
                {loading ? (
                    <div className="text-center text-textPrimary">{t('blogs.loading')}</div>
                ) : (
                    <>
                        <div className="flex flex-wrap justify-center gap-4 sm:gap-8">
                            {displayedBlogs.map((blog, index) => (
                                <BlogCard
                                    key={blog.id || index}
                                    blogId={blog.id}
                                    title={blog.title}
                                    summary={blog.description}
                                    date={blog.date}
                                    image={blog.photoID}
                                    index={index}
                                    onOpenModal={handleOpenModal}
                                />
                            ))}
                        </div>
                       
                        {hasMoreBlogs && (
                            <div className="text-center mt-12">
                                <button
                                    onClick={handleSeeMore}
                                    className="bg-primary hover:bg-secondary text-white font-semibold py-3 px-8 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg"
                                >
                                    {t('blogs.seeMore')}
                                </button>
                            </div>
                        )}
                    </>
                )}
            </section>

            <BlogModal 
                blog={selectedBlog}
                isOpen={isModalOpen}
                onClose={handleCloseModal}
            />
        </>
    );
}